<template>
  <input 
    @input="debounceInput"
    type="text" 
    :value="value"
    placeholder="Enter (partial) first- and/or last name"
    class="v-text-filter no-margin">
</template>

<script>
import { debounce } from 'debounce'

export default {
  name: 'TextFilter',
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  methods: {
    debounceInput: debounce(function (e) {
      let val = e.target.value.replace(/[^\w\s]/gi, '')
      this.$emit('update-filter', { key: this.options.name, value: val })
    }, 1000)
  },
  computed: {
    filteredValue () {
      return this.value.replace(/[^\w\s]/gi, '')
    }
  }
}

</script>
